import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=2ced1316&scoped=true"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"
import style0 from "./Cookie.vue?vue&type=style&index=0&id=2ced1316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced1316",
  null
  
)

export default component.exports